module.exports = __webpack_public_path__ + "static/media/taImg2.60259abd.png";